// removed by extract-text-webpack-plugin
module.exports = {"NotFound":"_2PikHNLyFPWMOOfzth2FkM _16iYTd8VD3FuBEOlDyCt9a","background":"uzoWHF9qPEdLj_bX7CNcX","fade-in":"HUawXbHL-CqLultcmUPWX","content":"d0mosakeQ3fQ0cvFRnd1p"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/notfound/NotFound.css
// module id = 247
// module chunks = 8